var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeTipsAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0064 27.5522C29.0371 27.5213 29.0662 27.4914 29.0937 27.4629H30.25C34.116 27.4629 37.25 30.5969 37.25 34.4629V36.6035C37.25 38.8127 35.4591 40.6035 33.25 40.6035H14.75C12.5409 40.6035 10.75 38.8127 10.75 36.6035V34.4629C10.75 30.5969 13.884 27.4629 17.75 27.4629H19.0172C19.038 27.4856 19.0597 27.509 19.0823 27.533C19.3272 27.794 19.6837 28.1409 20.135 28.4892C21.0226 29.1742 22.366 29.9322 24 29.9322C25.6289 29.9322 27.0005 29.1783 27.9136 28.5005C28.379 28.1551 28.7503 27.811 29.0064 27.5522Z",
    stroke: "#34303D",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 15.5957,
    r: 8.46094,
    stroke: "#34303D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2363 33.7094H33.2431",
    stroke: "#00D1D2",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6503 17.1487C27.9377 19.0453 26.0139 20.3613 23.8684 20.3613C21.8213 20.3613 20.2532 18.9087 19.4771 17.1487",
    stroke: "#00D1D2",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeTipsAccount);
export default __webpack_public_path__ + "static/media/welcome-tips-account.cb13d674302c17dabde912150426b5af.svg";
export { ForwardRef as ReactComponent };